import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HeatingGlyph = /*#__PURE__*/createElement("g", {
  id: "heating"
}, /*#__PURE__*/createElement("path", {
  d: "M28.5,54.8c-0.5,0.7-0.4,1.7,0.3,2.2c0.3,0.2,0.6,0.3,0.9,0.3c0.1,0,0.1,0,0.2,0c0.4-0.1,0.8-0.3,1-0.6 c4-5.1,4.2-13.1,0.5-18.6c-3-4.4-2.9-10.8,0.4-14.9c0.3-0.3,0.4-0.7,0.3-1.1c-0.1-0.4-0.3-0.8-0.6-1c-0.3-0.3-0.7-0.4-1.1-0.3 c-0.4,0.1-0.8,0.3-1,0.6c-4,5.1-4.2,13.1-0.5,18.5C32,44.4,31.9,50.4,28.5,54.8z"
}), /*#__PURE__*/createElement("path", {
  d: "M40.3,54.8c-0.5,0.7-0.4,1.7,0.3,2.2c0.3,0.2,0.6,0.3,0.9,0.3c0.1,0,0.1,0,0.2,0c0.4-0.1,0.8-0.3,1-0.6 c4-5.1,4.2-13.1,0.5-18.6c-3-4.4-2.9-10.8,0.4-14.9c0.2-0.3,0.4-0.7,0.3-1.1s-0.3-0.8-0.6-1c-0.3-0.3-0.7-0.4-1.1-0.3 c-0.4,0.1-0.8,0.3-1,0.6c-4,5.1-4.2,13.1-0.5,18.5C43.8,44.4,43.7,50.4,40.3,54.8z"
}), /*#__PURE__*/createElement("path", {
  d: "M52.2,54.8c-0.5,0.7-0.4,1.7,0.3,2.2c0.3,0.2,0.6,0.3,0.9,0.3c0.1,0,0.1,0,0.2,0c0.4-0.1,0.8-0.3,1-0.6 c4-5.1,4.2-13.1,0.5-18.6c-3-4.4-2.9-10.8,0.4-14.9c0.3-0.3,0.4-0.7,0.3-1.1c-0.1-0.4-0.3-0.8-0.6-1c-0.3-0.3-0.7-0.4-1.1-0.3 s-0.8,0.3-1,0.6c-4,5.1-4.2,13.1-0.5,18.5C55.7,44.4,55.5,50.4,52.2,54.8z"
}), /*#__PURE__*/createElement("path", {
  d: "M22,60.5V61c0,1.2,1,2.3,2.3,2.3h35.4c1.2,0,2.3-1,2.3-2.3v-0.5H22z"
}));
const Heating = createSvg({
  name: 'heating',
  path: HeatingGlyph
});

export default Heating;
export { HeatingGlyph };
